// NOTE: From MRCS50.dbo.ContactResultType
export enum CallResultType {
  None = 0,
  Successful = 1,
  Unsuccessful = 2,
}
